import { AppConfig } from './definitions/app-config.interface';

export const DEFAULT_THEME = 'klobal';

// Themes other than the default one are built as lazy style bundles named `theme-<name>.css` (see angular.json)
export const THEMES = [DEFAULT_THEME, 'vyresime-skodu'];

const THEME_TITLES: Record<string, string> = {
  'klobal': 'Klobal Portal',
  'vyresime-skodu': 'Vyřešíme škodu - Portál'
};

function updateTitle(theme: string): void {
  document.title = THEME_TITLES[theme] ?? THEME_TITLES[DEFAULT_THEME];
}

function updateFavicon(theme: string): void {
  const iconPath: string = `assets/favicons/favicon-${theme}.ico`
  let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");

  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  link.type = 'image/x-icon';
  link.href = iconPath;
}

/**
 * Applies the theme selected by `theme` in app config: sets the `theme-<name>` class on <html>
 * and loads the theme stylesheet. Resolves once the stylesheet is loaded, so the app is first
 * rendered already themed. An unknown or missing theme falls back to the default one.
 */
export function applyTheme(config: AppConfig): Promise<void> {
  const theme = THEMES.includes(config.theme) ? config.theme : DEFAULT_THEME;

  updateFavicon(theme);
  updateTitle(theme);

  if (theme === DEFAULT_THEME) {
    return Promise.resolve();
  }

  document.documentElement.classList.add(`theme-${theme}`);

  return new Promise((resolve) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `theme-${theme}.css?v=${encodeURIComponent(config.appVersion)}`;
    // Don't block the app start when the stylesheet fails to load
    link.onload = () => resolve();
    link.onerror = () => resolve();
    document.head.appendChild(link);
  });
}
